import * as ambassadorWixLocationsV1Location from './locations-v1-location-locations.http.js';
import * as ambassadorWixLocationsV1LocationTypes from './locations-v1-location-locations.types.js';
import * as ambassadorWixLocationsV1LocationUniversalTypes from './locations-v1-location-locations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocationsV1LocationUniversalTypes.CreateLocationRequest,
  ambassadorWixLocationsV1LocationTypes.CreateLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.CreateLocationResponse,
  ambassadorWixLocationsV1LocationTypes.CreateLocationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.createLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/locations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocationsV1LocationUniversalTypes.BulkCreateLocationRequest,
  ambassadorWixLocationsV1LocationTypes.BulkCreateLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.BulkCreateLocationResponse,
  ambassadorWixLocationsV1LocationTypes.BulkCreateLocationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.bulkCreateLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/locations/bulk-create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLocation(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.GetLocationRequest,
  ambassadorWixLocationsV1LocationTypes.GetLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.GetLocationResponse,
  ambassadorWixLocationsV1LocationTypes.GetLocationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.getLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/locations/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listLocations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLocationsV1LocationUniversalTypes.ListLocationsRequest,
  ambassadorWixLocationsV1LocationTypes.ListLocationsRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.ListLocationsResponse,
  ambassadorWixLocationsV1LocationTypes.ListLocationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.listLocations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/locations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLocation(): __PublicMethodMetaInfo<
  'PUT',
  { locationId: string },
  ambassadorWixLocationsV1LocationUniversalTypes.UpdateLocationRequest,
  ambassadorWixLocationsV1LocationTypes.UpdateLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.UpdateLocationResponse,
  ambassadorWixLocationsV1LocationTypes.UpdateLocationResponse
> {
  const payload = { location: { id: ':locationId' } } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.updateLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/locations/{location.id}',
    pathParams: { locationId: 'locationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLocations(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLocationsV1LocationUniversalTypes.QueryLocationsRequest,
  ambassadorWixLocationsV1LocationTypes.QueryLocationsRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.QueryLocationsResponse,
  ambassadorWixLocationsV1LocationTypes.QueryLocationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.queryLocations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/locations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setDefaultLocation(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.SetDefaultLocationRequest,
  ambassadorWixLocationsV1LocationTypes.SetDefaultLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.SetDefaultLocationResponse,
  ambassadorWixLocationsV1LocationTypes.SetDefaultLocationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.setDefaultLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/locations/{id}/set-default',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archiveLocation(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.ArchiveLocationRequest,
  ambassadorWixLocationsV1LocationTypes.ArchiveLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.ArchiveLocationResponse,
  ambassadorWixLocationsV1LocationTypes.ArchiveLocationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.archiveLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/locations/{id}/archive',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addTypeToLocation(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.AddTypeToLocationRequest,
  ambassadorWixLocationsV1LocationTypes.AddTypeToLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.AddTypeToLocationResponse,
  ambassadorWixLocationsV1LocationTypes.AddTypeToLocationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.addTypeToLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/locations/{id}/add-type',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeTypeFromLocation(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.RemoveTypeFromLocationRequest,
  ambassadorWixLocationsV1LocationTypes.RemoveTypeFromLocationRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.RemoveTypeFromLocationResponse,
  ambassadorWixLocationsV1LocationTypes.RemoveTypeFromLocationResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.removeTypeFromLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/locations/{id}/remove-type',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addLocationType(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.AddLocationTypeRequest,
  ambassadorWixLocationsV1LocationTypes.AddLocationTypeRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.AddLocationTypeResponse,
  ambassadorWixLocationsV1LocationTypes.AddLocationTypeResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.addLocationType(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/locations/{id}/add-location-type',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeLocationType(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string },
  ambassadorWixLocationsV1LocationUniversalTypes.RemoveLocationTypeRequest,
  ambassadorWixLocationsV1LocationTypes.RemoveLocationTypeRequest,
  ambassadorWixLocationsV1LocationUniversalTypes.RemoveLocationTypeResponse,
  ambassadorWixLocationsV1LocationTypes.RemoveLocationTypeResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixLocationsV1Location.removeLocationType(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/locations/{id}/remove-location-type',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Location as LocationOriginal,
  LocationStatus as LocationStatusOriginal,
  LocationStatusWithLiterals as LocationStatusWithLiteralsOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateLocationRequest as CreateLocationRequestOriginal,
  CreateLocationResponse as CreateLocationResponseOriginal,
  BulkCreateLocationRequest as BulkCreateLocationRequestOriginal,
  BulkCreateLocationResponse as BulkCreateLocationResponseOriginal,
  FailedCreateLocation as FailedCreateLocationOriginal,
  GetLocationRequest as GetLocationRequestOriginal,
  GetLocationResponse as GetLocationResponseOriginal,
  ListLocationsRequest as ListLocationsRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  ListLocationsResponse as ListLocationsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  UpdateLocationRequest as UpdateLocationRequestOriginal,
  UpdateLocationResponse as UpdateLocationResponseOriginal,
  BulkUpdateLocationRequest as BulkUpdateLocationRequestOriginal,
  BulkUpdateLocationResponse as BulkUpdateLocationResponseOriginal,
  FailedUpdateLocation as FailedUpdateLocationOriginal,
  QueryLocationsRequest as QueryLocationsRequestOriginal,
  Query as QueryOriginal,
  QueryLocationsResponse as QueryLocationsResponseOriginal,
  GetOrCreateDefaultLocationRequest as GetOrCreateDefaultLocationRequestOriginal,
  GetOrCreateDefaultLocationResponse as GetOrCreateDefaultLocationResponseOriginal,
  SetDefaultLocationRequest as SetDefaultLocationRequestOriginal,
  SetDefaultLocationResponse as SetDefaultLocationResponseOriginal,
  SetDefaultLocation as SetDefaultLocationOriginal,
  ArchiveLocationRequest as ArchiveLocationRequestOriginal,
  ArchiveLocationResponse as ArchiveLocationResponseOriginal,
  ArchiveLocation as ArchiveLocationOriginal,
  UnarchiveLocationRequest as UnarchiveLocationRequestOriginal,
  UnarchiveLocationResponse as UnarchiveLocationResponseOriginal,
  AddTypeToLocationRequest as AddTypeToLocationRequestOriginal,
  AddTypeToLocationResponse as AddTypeToLocationResponseOriginal,
  RemoveTypeFromLocationRequest as RemoveTypeFromLocationRequestOriginal,
  RemoveTypeFromLocationResponse as RemoveTypeFromLocationResponseOriginal,
  MetasiteLocationsRequest as MetasiteLocationsRequestOriginal,
  MetasiteLocationsResponse as MetasiteLocationsResponseOriginal,
  AddLocationTypeRequest as AddLocationTypeRequestOriginal,
  AddLocationTypeResponse as AddLocationTypeResponseOriginal,
  RemoveLocationTypeRequest as RemoveLocationTypeRequestOriginal,
  RemoveLocationTypeResponse as RemoveLocationTypeResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateLocationApplicationErrors as CreateLocationApplicationErrorsOriginal,
  UpdateLocationApplicationErrors as UpdateLocationApplicationErrorsOriginal,
  SetDefaultLocationApplicationErrors as SetDefaultLocationApplicationErrorsOriginal,
  ArchiveLocationApplicationErrors as ArchiveLocationApplicationErrorsOriginal,
  AddTypeToLocationApplicationErrors as AddTypeToLocationApplicationErrorsOriginal,
  RemoveTypeFromLocationApplicationErrors as RemoveTypeFromLocationApplicationErrorsOriginal,
  AddLocationTypeApplicationErrors as AddLocationTypeApplicationErrorsOriginal,
  RemoveLocationTypeApplicationErrors as RemoveLocationTypeApplicationErrorsOriginal,
} from './locations-v1-location-locations.types.js';
